import { createContext, useContext, useState } from "react";

const Ctx = createContext(null);

// Shared state so the incident-detail KB panel and the sidebar "Procedures"
// button (in CommandLayout) can coordinate: hit count (for flashing), the
// open/closed panel, whether an incident context is active, and whether the
// hits came from a (keyword) in the notepad (yellow flash).
export function ProceduresProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [hits, setHits] = useState(0);
  const [active, setActive] = useState(false);
  const [keyword, setKeyword] = useState(false);
  return (
    <Ctx.Provider value={{ open, setOpen, hits, setHits, active, setActive, keyword, setKeyword }}>
      {children}
    </Ctx.Provider>
  );
}

export function useProcedures() {
  return useContext(Ctx) || { open: false, setOpen: () => {}, hits: 0, setHits: () => {}, active: false, setActive: () => {}, keyword: false, setKeyword: () => {} };
}
